var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 128.000000 128.000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65 1271 c-11 -5 -29 -19 -40 -31 -20 -22 -20 -36 -20 -601 l0 -579 28 -27 27 -28 465 0 465 0 27 28 c28 27 28 30 31 165 l3 137 104 105 c56 58 108 116 115 129 17 34 4 82 -35 128 -55 65 -105 82 -169 57 -14 -5 -16 9 -16 123 l0 128 -138 138 -137 137 -345 -1 c-190 0 -354 -4 -365 -8z m675 -115 l0 -75 -47 -3 c-40 -3 -48 -6 -48 -23 0 -17 8 -20 49 -23 38 -3 58 -10 83 -33 32 -28 38 -29 128 -29 l95 0 0 -137 0 -138 -154 -155 -154 -155 -41 -130 c-53 -171 -55 -169 115 -115 120 38 133 45 182 93 l52 51 0 -99 c0 -78 -3 -102 -17 -117 -15 -17 -43 -18 -456 -18 -396 0 -442 2 -459 17 -17 15 -18 46 -18 571 0 503 2 557 17 574 15 17 39 18 345 18 l328 0 0 -74z m154 -134 c-92 -4 -104 8 -104 102 l0 71 85 -85 86 -85 -67 -3z m288 -349 c52 -51 57 -66 32 -102 l-17 -23 -69 69 -69 68 22 18 c32 26 49 21 101 -30z m-244 -210 l-137 -137 -26 24 -26 24 138 138 138 138 25 -25 25 -25 -137 -137z m200 74 l22 -23 -138 -137 -138 -138 -24 26 -24 26 134 134 c74 74 137 135 141 135 3 0 15 -10 27 -23z m-353 -267 c51 -52 52 -54 20 -64 -30 -9 -97 60 -89 92 4 12 9 22 13 22 4 0 29 -22 56 -50z m-71 -91 c-5 -9 -34 -13 -34 -5 0 2 3 12 6 20 5 13 9 14 20 5 8 -6 11 -15 8 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 1067 c-2 -7 -3 -62 -2 -123 l3 -109 190 0 190 0 0 120 0 120 -188 3 c-149 2 -189 0 -193 -11z m336 -112 l0 -75 -145 0 -145 0 0 75 0 75 145 0 145 0 0 -75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 865 c-11 -30 12 -36 128 -33 106 3 114 4 114 23 0 19 -8 20 -118 23 -100 2 -118 0 -124 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 664 c-3 -8 -1 -20 4 -25 5 -5 124 -8 294 -7 276 3 284 4 284 23 0 19 -8 20 -288 23 -255 2 -288 0 -294 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813 664 c-8 -21 13 -42 28 -27 13 13 5 43 -11 43 -6 0 -13 -7 -17 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 465 c-3 -9 -1 -21 4 -26 5 -5 109 -8 254 -7 236 3 244 4 244 23 0 19 -8 20 -248 23 -218 2 -248 0 -254 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 266 c-9 -10 -8 -16 4 -26 19 -16 41 1 32 24 -8 20 -21 20 -36 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274 265 c-12 -31 7 -35 155 -35 111 0 151 3 160 13 24 29 -9 37 -161 37 -121 0 -150 -3 -154 -15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobCreate);
export default __webpack_public_path__ + "static/media/jobCreate.926dff86bae434e677edbd40a42574a2.svg";
export { ForwardRef as ReactComponent };